export default "__VITE_ASSET__BmuV5MKZ__"